import { mapState, mapActions } from 'vuex';
import {
  addToCartEventData,
  trackProductClick,
  buildItemTrackingData,
  setLocalStorageProperties,
} from 'lib/tracking';
import datalayer from 'lib/datalayer';
import productBundle from 'mixins/product-bundle';
import {
  getStarsHTML,
  getStarsLabel,
  cleanseProductJson,
  decode,
} from 'utils/general';

export default {
  name: 'Related product',
  props: ['product', 'decode', 'parentTitle'],
  mixins: [productBundle],
  data() {
    let relatedProduct;
    if (!!this.decode && this.product) {
      relatedProduct = JSON.parse(decode(this.product));
    } else {
      relatedProduct = this.product || {
        title: '',
        price: '',
        featuredImage: '',
        variants: [],
        optionNames: [],
        optionsWithValues: {},
        reviews: {},
      };
    }
    relatedProduct = cleanseProductJson(relatedProduct);

    return {
      relatedProduct: relatedProduct,
      productIdInt: null,
      hasMultiSwatch: false,
      isAvailable: false,
      CTAType: null,
      shadeCount: true,
    };
  },
  created() {
    this.CTAType = this.getCTAType();
  },
  async mounted() {
    this.shadeCount = this.relatedProduct.shadeCount
      ? this.relatedProduct.shadeCount > 1
      : false;
    if (this.relatedProduct.bundledProducts.length) {
      this.isBundle = true;
      await this.fetchBundleProductsByHandles(
        this.relatedProduct.bundledProducts,
      );
    }
  },
  computed: {
    ...mapState('global'),
    relatedProductStars() {
      if (!this.relatedProduct?.reviewsAverage) return '';
      return getStarsHTML(this.relatedProduct.reviewsAverage);
    },
    starsAriaLabel() {
      return getStarsLabel(this.relatedProduct);
    },
  },
  methods: {
    ...mapActions('cart', [
      'addToCart',
      'openCart',
      'closeCart',
      'addBundleItemsToCart',
    ]),
    handleCtaClick(event) {
      window.dataLayer.push({
        event: 'productRelated',
        productName: this.relatedProduct.title.split(
          window.__GLOBAL__.productDelimiter,
        )[0],
      });

      this.handleTracking(event);
    },
    async handleTracking(event) {
      event.preventDefault();

      const otherData = {
        origin: document.body.dataset.origin,
        originProduct: document.body.dataset.originProduct,
        index: 0,
      };

      const listData = {
        listName: this.parentTitle,
        listId: 'pdp-related-product',
        index: 0,
        moduleName: 'related product'
      };

      const productObject = this.relatedProduct;
      let itemObject = [];
      if (this.isBundle) {
        otherData.bundleName = productObject.title;
        otherData.bundleId = productObject.id;
        listData.bundleName = productObject.title;
        listData.bundleId = productObject.id;

        itemObject = this.bundleProductsData.map((bundle) => {
          bundle.isBundle = true;
          return buildItemTrackingData(bundle, 1, otherData);
        });
      } else {
        itemObject = buildItemTrackingData(productObject, 1, otherData);
      }

      setLocalStorageProperties(otherData, listData);
      trackProductClick('select_item', itemObject, listData);

      setTimeout(() => {
        window.location = this.relatedProduct.url;
      }, 800);
    },
    async getCTAType() {
      const isAvailable = await this.getProductAvailability();

      if (isAvailable && !this.shadeCount) {
        this.CTAType = 'add';
        return 'add';
      }

      this.CTAType = 'full-details';
      return 'full-details';
    },
    async getProductAvailability() {
      if (!this.isBundle) return this.relatedProduct.available;

      return this.isBundleUnavailable();
    },
    async addItemToCart() {
      const callback = () => {
        setTimeout(() => {
          this.closeCart();
        }, 2500);
      };

      const item = this.relatedProduct;
      let properties = null;

      if (item.tags?.includes('preorder')) {
        properties = { _Preorder: 'true' };
      }

      properties = {
        ...properties,
        _product_collection: item.categories ? item.categories[0] : null,
        _product_tags: item.tags,
        _product_rating: item.reviewsAverage,
        _upsell_bundle: item.cartUpsellBundle,
        _promo_text: item.promoText,
        _promo_link: item.link,
        _origin: document.body.dataset.origin,
        _origin_product: document.body.dataset.originProduct,
        _item_list_id: this.parentTitle,
        _item_list_name: 'pdp-related-product',
        _index: 0,
      };

      if (this.isBundle) {
        this.addBundleToCart({
          price: item.price,
          title: item.title,
          productObject: item,
          quantity: 1,
          callback,
          properties,
        });
      } else {
        if (item.tags?.includes('preorder')) {
          properties._Preorder = 'true';
        }

        const sameIdProducts = this.cart.items.filter(
          (cartItem) => cartItem.product_id === (item.variants && item.variants.length > 0 ? item.variants[0].id : item.id)
        );

        const sameIDProductsQuantity = sameIdProducts?.reduce(
          (acc, rec) => (acc = acc + rec.quantity),
          0,
        );

        if (!sameIDProductsQuantity || sameIDProductsQuantity < 5) {
          this.addToCart({
            id: item?.variants[0]?.id ? item.variants[0].id : item.id,
            quantity: 1,
            callback,
            properties,
            moduleName: 'related product'
          });
        }
      }

      const extraData = {
        addToCartType: 'Product Detail Page',
        sku: item?.variants[0]?.sku ? item.variants[0].sku : item?.sku,
        variant: item,
      };

      const productInfo = await addToCartEventData(item, 1, extraData);
      if (productInfo) {
        datalayer.dataLayerPush('addToCart', productInfo);
      }
    },
  },
};
